var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.845,
    height: 24.676,
    viewBox: "0 0 38.845 24.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-582.506 -660.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 38.845,
    height: 24.676,
    transform: "translate(582.506 660.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 37.55,
    height: 3.366,
    transform: "translate(583.153 681.452)",
    fill: "#fbaf18"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 37.55,
    height: 3.367,
    transform: "translate(583.153 661.433)",
    fill: "#29297f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M141.644,33.873l-3.879,9.253h-2.531l-1.908-7.385a1.018,1.018,0,0,0-.569-.812,9.981,9.981,0,0,0-2.362-.787l.056-.268h4.074a1.117,1.117,0,0,1,1.1.942l1.008,5.355,2.49-6.3h2.515m9.915,6.232c.01-2.442-3.376-2.577-3.354-3.668.008-.332.324-.686,1.015-.775a4.515,4.515,0,0,1,2.361.414L152,34.113a6.433,6.433,0,0,0-2.239-.41c-2.367,0-4.032,1.258-4.045,3.059-.015,1.332,1.189,2.075,2.1,2.518.933.454,1.247.745,1.242,1.15-.006.621-.745.9-1.432.906a5,5,0,0,1-2.459-.585l-.434,2.028a7.253,7.253,0,0,0,2.661.491c2.516,0,4.161-1.242,4.169-3.166m6.249,3.021h2.214l-1.934-9.253h-2.042a1.089,1.089,0,0,0-1.02.679l-3.592,8.575h2.514l.5-1.382h3.072Zm-2.672-3.279,1.26-3.475.725,3.475Zm-10.071-5.974-1.98,9.253H140.69l1.98-9.253Z",
    transform: "translate(456.223 634.636)",
    fill: "#29297f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.a37f9039.svg";
export { ForwardRef as ReactComponent };